import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './cobros-honorarios.module.css';
import { MyIcons } from '../../components/icons/my-icons';
import { useModal } from '../../contexts/ModalContext';

const CobrosHonorariosPage = () => {
  const navigate = useNavigate();
  const { openModal } = useModal();
  const userRole = localStorage.getItem("userRole") || "ROLE_USER";

  // Solo ADMIN puede acceder a esta página
  if (userRole !== "ROLE_ADMIN") {
    navigate(-1);
    return null;
  }

  const handleItemClick = (modalName) => {
    openModal(modalName);
  };

  const cobrosItems = [
    {
      id: 'dar-cobrado',
      title: 'Dar por Cobrado',
      description: 'Marcar facturas como cobradas manualmente',
      icon: 'stats',
      modalName: 'DarCobradoModal',
      color: '#4CAF50'
    },
    {
      id: 'quitar-cobrado',
      title: 'Quitar Cobrado',
      description: 'Remover el estado cobrado de una factura',
      icon: 'alert',
      modalName: 'QuitarCobradoModal',
      color: '#FF9800'
    },
    {
      id: 'honorarios-pagados',
      title: 'Honorarios Pagados',
      description: 'Gestión de honorarios pagados a comerciales',
      icon: 'user',
      modalName: 'HonorariosPagadosModal',
      color: '#2196F3'
    }
  ];

  const renderItemCard = (item) => {
    return (
      <div
        key={item.id}
        className={styles.itemCard}
        onClick={() => handleItemClick(item.modalName)}
      >
        <div className={styles.itemContent}>
          <h3 className={styles.itemTitle}>{item.title}</h3>
          <p className={styles.itemDescription}>{item.description}</p>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Cobros y Honorarios</h1>
        <p className={styles.subtitle}>
          Gestión de cobros de facturas y honorarios comerciales
        </p>
      </div>

      <div className={styles.content}>
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Gestión Financiera</h2>
          </div>
          <p className={styles.sectionDescription}>
            Herramientas para administración de cobros y honorarios
          </p>
          <div className={styles.itemGrid}>
            {cobrosItems.map(renderItemCard)}
          </div>
        </section>

        <div className={styles.infoBox}>
          <div className={styles.infoContent}>
            <h4 className={styles.infoTitle}>⚠️ Acceso Restringido</h4>
            <p className={styles.infoText}>
              Esta sección solo está disponible para administradores del sistema.
              Las operaciones realizadas aquí afectan directamente a la contabilidad y finanzas.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CobrosHonorariosPage;
